export default __webpack_public_path__ + "static/media/bumblebee.abf181aa.jpg";